export const combine = (...classes: (string | boolean | undefined)[]): string => {
    return classes.filter(x => x).join(' ');
};
